export const FIND_TAG_REQUEST = 'FIND_TAG_REQUEST';

export const findTagRequest = ( id: string ) => ({
    type: FIND_TAG_REQUEST,
    payload: { id }
});
